var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGemJarHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 32,
    viewBox: "0 0 115 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84693 0L0 8.88887H10.1345L4.84693 0Z",
    fill: "#C3C3C3",
    fillOpacity: 0.32
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0684 0L13.2214 8.88887H23.3559L18.0684 0Z",
    fill: "#C3C3C3",
    fillOpacity: 0.32
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2826 0L26.4357 8.88887H36.5702L31.2826 0Z",
    fill: "#C3C3C3",
    fillOpacity: 0.32
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1184 11.5552L20.2715 20.444H30.406L25.1184 11.5552Z",
    fill: "#307A64"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7245 20.4448L36.5714 11.556L26.4369 11.556L31.7245 20.4448Z",
    fill: "#C3C3C3",
    fillOpacity: 0.32
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5102 20.4448L23.3572 11.556L13.2227 11.556L18.5102 20.4448Z",
    fill: "#C3C3C3",
    fillOpacity: 0.32
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4567 8.88916L16.3036 0.000287056L6.16909 0.000287056L11.4567 8.88916Z",
    fill: "#C3C3C3",
    fillOpacity: 0.32
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6746 8.88916L29.5215 0.000287056L19.387 0.000287056L24.6746 8.88916Z",
    fill: "#307A64"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28881 20.4448L10.1357 11.556L0.00124454 11.556L5.28881 20.4448Z",
    fill: "#C3C3C3",
    fillOpacity: 0.32
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3424 32L17.1893 23.1111H7.05483L12.3424 32Z",
    fill: "#307A64"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5531 32L30.4 23.1111H20.2655L25.5531 32Z",
    fill: "#307A64"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9005 11.5552L7.05359 20.444H17.1881L11.9005 11.5552Z",
    fill: "#307A64"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9469 23.1108L14.1 31.9997H24.2345L18.9469 23.1108Z",
    fill: "#307A64"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.227 28.6883H64.1829L72.3796 9.33932L74.2712 15.3442L69.227 28.6883Z",
    fill: "#5BAA93"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2712 3.33447H79.9459L88.1426 28.6883H83.0985L81.4189 23.8643H73.7518V20.0001H80.0736L74.2712 3.33447Z",
    fill: "#5BAA93"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6121 3H56.5007V23L54.5839 25H50.1114L47.5557 22.3333L45 25L49.4725 29H57.1396L61.6121 24.3333V3Z",
    fill: "#307A64"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0403 7.17021V2H108.035L113.7 7.17021V15.2128L108.035 19.8085L115 28.6882H108.664L102.173 19.8085H96.0757V29H91.0403V15.2128H106.776L108.664 13.4894V8.89362L106.776 7.17021H91.0403Z",
    fill: "#307A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemJarHeaderLogo);
export default __webpack_public_path__ + "static/media/gemJarHeaderLogo.87f98179381886ffeab4907c3c26f135.svg";
export { ForwardRef as ReactComponent };